
export const ASSET_CLASS_COLORS = {
  equity: "#1B3668",      // Deep blue for Equity (Canadian terminology)
  fixed_income: "#4F6D7A", // Blue gray for Fixed Income (Canadian terminology)
  cash: "#C6AC8F",        // Light brown for Cash
  alternative: "#CBA135", // Gold for Alternatives
  multi_asset: "#2B2D42", // Dark blue/gray for Multi-Asset
  unclassified: "#848482" // Medium gray for Unclassified
};

export const STRATEGY_COLORS = {
  preservation: "#2B2D42",     // Dark blue/gray
  income: "#355070",          // Medium blue
  growth: "#CBA135",         // Gold
  diversification: "#4F6D7A", // Blue gray
  custom: "#848482"          // Medium gray
};
